import { ItemBadge } from "@coworker/apprestructured/src/shared/types/ItemBadge";
import styles from "@coworker/apprestructured/src/media-maintenance/styles/common-media-styles.module.css";
import FixaLink from "@coworker/apprestructured/src/shared/wrappers/FixaLink/FixaLink";
import React from "react";
import { ItemImage } from "@coworker/apprestructured/src/shared/components/item-cards/ItemImage/ItemImage";
import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";
import { ItemDescription } from "@coworker/apprestructured/src/shared/components/item-cards/ItemDescription/ItemDescription";
import { MediaItemEds } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/MediaItemEds/MediaItemEds";
import { ItemCard } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCard/ItemCard";
import { ItemTotalInMedia } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/ItemTotalInMedia/ItemTotalInMedia";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { EdsData } from "@coworker/app/src/components/RoomSettings/types/article";
import { ItemNo } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNo/ItemNo";

interface MediaItemCardSearchProps {
  item: Item;
  amountOfMedias: number;
  edsData?: EdsData | null;
  badges?: ItemBadge[];
}

export const MediaItemCardSearch = ({
  badges,
  edsData,
  item,
  amountOfMedias,
}: MediaItemCardSearchProps) => {
  const navigationUrl = `/mediamaintenance/articles/search/${item.no}`;
  return (
    <ItemCard
      badges={badges as ItemBadge[]}
      dataTestId={"media-item-card-search"}
      className={styles["item-card-search-root"]}
    >
      <FixaLink to={navigationUrl} className={styles["item-card-root-row"]}>
        <ItemImage imageUrl={item.smallImageUrl || ""} />
        <div className={styles["item-card-root-column"]}>
          <ItemName name={item.name} />
          <ItemNo itemNo={item.noFormatted} />
          <ItemDescription description={item.description || ""} />
          <ItemTotalInMedia amountOfMedias={amountOfMedias} />
          {edsData && <MediaItemEds edsData={edsData} />}
        </div>
      </FixaLink>
    </ItemCard>
  );
};
